import {writable} from "svelte/store";

const countersStore = writable({
  trainerClientPrograms: 0,
});

export {countersStore};
